import type { BaseKeyFunction } from "../../../lib";

export const keyRoutine: BaseKeyFunction = () => ["routine"];
